"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var loader_1 = require("../../build-babel/form/loader");
var init_1 = require("../../build-babel/form/init");
var errorHander_1 = require("../../build-babel/form/errorHander");
var forgotPassword_1 = require("../../build-babel/form/forgotPassword");
var form_1 = require("../../build-babel/analytics/ga/form");
// these scripts are executed on identity.* domain
(0, loader_1.loadScript)(init_1.initForm);
(0, loader_1.loadScript)(forgotPassword_1.initForgotPasswordPage);
(0, loader_1.loadScript)(errorHander_1.initErrorHandler);
(0, loader_1.loadScript)(form_1.initGAForm);
//# sourceMappingURL=index.js.map